
/* injects from baggage-loader */

'use strict';
import { ShapeConst } from '_appRoot/index.const';
import { fabric } from 'fabric';

import { assign } from 'lodash';

export default function (app) {
    app
        .factory('$Fabric', FabricFactory);

    function FabricFactory() {
        'ngInject';

        // Global Config Fabric, disabled controls in group

        fabric.Group.prototype.hasControls = false

        let self = {};        

        self.create = function(id){
            return new fabric.Canvas(id);
        }

        self.addShape = function(canvas, shape, config){
            let newShape = null;

            switch (shape.type) {
                case ShapeConst.types.circle:
                    newShape = self.addCircle(canvas, shape, config);
                    break;            
                case ShapeConst.types.triangle:
                    newShape = self.addTriangle(canvas, shape, config);
                    break;            
                case ShapeConst.types.square:
                    newShape = self.addRect(canvas, shape, config);
                    break;            
                case ShapeConst.types.rect:
                    newShape = self.addRect(canvas, shape, config);
                    break;            
                default:
                    break;
            }

            canvas.setActiveObject(canvas.item(canvas._objects.length - 1));

            return newShape;
        }

        self.addRect = function (canvas, shape, config){
            let rect = new fabric.Rect();
            
            this.setShapeConfig(rect, shape, config);

            canvas.add(rect);

            // rect.center();

            return rect;
        }

        self.addCircle = function (canvas, shape, config){
            let circle = new fabric.Circle();
            
            circle.radius = shape.size === ShapeConst.sizes.big ? 20 : 12.5;
            
            this.setShapeConfig(circle, shape, config);

            canvas.add(circle);

            // circle.center();

            return circle;
        }

        self.addSquare = function (canvas, shape, config){
            let rect = new fabric.Rect();
            
            this.setShapeConfig(rect, shape, config);

            canvas.add(rect);

            // rect.center();

            return rect;
        }

        self.addTriangle = function (canvas, shape, config){
            let triangle = new fabric.Triangle();
            
            this.setShapeConfig(triangle, shape, config);

            canvas.add(triangle);

            // triangle.center();

            return triangle;
        }

        self.setShapeConfig = function (fabricShape, shape, config){
            // Define Global
            let global = assign(config, {
                hasControls: false, 
                $type: shape.type, 
                $color: shape.color, 
                $size: shape.size 
            });

            fabricShape.set(global);
            
            this.setColor(fabricShape, shape);
            this.setSize(fabricShape, shape);

            return fabricShape;
        }

        self.setColor = function(fabricShape, shape){
            switch (shape.color) {
                case ShapeConst.colors.yellow:
                    fabricShape.fill = '#f9a715'
                    fabricShape.stroke = '#700f02';
                    fabricShape.strokeWidth = 1;
                    break;
                case ShapeConst.colors.red:
                    fabricShape.fill = '#aa1602'
                    fabricShape.stroke = '#700f02';
                    fabricShape.strokeWidth = 1;
                    break;
                case ShapeConst.colors.blue:
                    fabricShape.fill = '#073184'
                    fabricShape.stroke = '#06296b';
                    fabricShape.strokeWidth = 1;
                    break;
                default:
                    break;
            }
        }

        self.setSize = function (fabricShape, shape){
            switch (shape.size) {
                case ShapeConst.sizes.small:
                    if (shape.type !== ShapeConst.types.rect){
                        fabricShape.width = 24;
                        fabricShape.height = 25;
                    } else {                        
                        fabricShape.width = 25;
                        fabricShape.height = 19;
                    }
                    break;
                case ShapeConst.sizes.big:
                    if (shape.type !== ShapeConst.types.rect) {
                        fabricShape.width = 38;
                        fabricShape.height = 38;
                    } else {
                        fabricShape.width = 39;
                        fabricShape.height = 28;
                    }
                    break;                
                default:
                    break;
            }
        }

        return self;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/fabric.factory.js